export default function ValueProposition() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="w-full lg:w-[42%]">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20lifestyle%20photography%20of%20modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%2C%20surrounded%20by%20product%20samples%20and%20shopping%20items%2C%20soft%20natural%20daylight%20from%20window%2C%20clean%20cream%20and%20warm%20beige%20aesthetic%2C%20editorial%20tech%20lifestyle%20photography%2C%20cozy%20home%20office%20atmosphere%2C%20gentle%20shadows%2C%20premium%20modern%20feel&width=800&height=1000&seq=gtbuy-value-prop&orientation=portrait"
                alt="Why GTBuy Spreadsheet beats random browsing"
                className="w-full h-auto"
              />
            </div>
          </div>

          <div className="w-full lg:w-[58%]">
            <span className="text-xs font-medium uppercase tracking-wider text-accent-500">
              Data-Driven Deals
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mt-3 mb-2 leading-tight">
              Why GTBuy Spreadsheet
            </h2>
            <p className="text-2xl md:text-4xl font-heading font-bold text-foreground-400 leading-tight">
              Beats Random Browsing
            </p>

            <div className="mt-8 md:mt-10">
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-lg">
                &ldquo;The GTBuy Spreadsheet system changed how I shop online. Instead of jumping between five different websites comparing prices manually, I now see everything in one structured spreadsheet. The Kakobuy Spreadsheet and Superbuy Spreadsheet integrations give me data I never had access to before. It literally saves me hours every week and hundreds of dollars every month.&rdquo;
              </p>
              <p className="mt-5 text-foreground-800 font-semibold text-sm">
                &mdash; GTBuy Garden Team
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Start Comparing Now
                <i className="ri-arrow-right-line ml-1.5"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}